import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import QRCodeRegistration from 'components/QRCodeRegistration'
import Button from 'components/Button'
import useInterval from 'hooks/useInterval'
import Version from 'components/Version'

const HALF_MINUTE = 30000

const RegisterDevice = ({ history }) => {
  const handleRedirect = () => {
    history.push('/device-login')
  }

  useInterval(() => {
    history.push('/device-login')
  }, HALF_MINUTE)

  return (
    <section className="register-device">
      <section className="register-device__bg">
        <header>
          <h1 className="register-device__header">Register Device</h1>
        </header>
        <QRCodeRegistration />
        <h2 className="register-device__label">Scan with camera</h2>
      </section>
      <Button className="-lg" onClick={handleRedirect} title="DONE" />
      <p className="register-device__token">
        <Version />
        <span>{window.localStorage.getItem('device_id')}</span>
      </p>
    </section>
  )
}

RegisterDevice.propTypes = {
  history: PropTypes.object,
}

export default withRouter(RegisterDevice)
